export enum HttpStatus {
  Ok = 200,
  Created = 201,
  Accepted = 202,
  BadRequest = 400,
  NotFound = 404,
  InternalServerError = 500,
  GatewayTimeout = 504,
}
